import { render } from "./Mining.vue?vue&type=template&id=3256b133"
import script from "./Mining.vue?vue&type=script&lang=js"
export * from "./Mining.vue?vue&type=script&lang=js"
script.render = render

export default script